import { IEpletMismatch } from '@nkr/models/index';
import { Button, Col, Glyphicon, OverlayTrigger, Row } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import { EpletDetailsTableWrapper } from './styles';

interface IProps {
    eplet: IEpletMismatch,
    isAdmin: boolean,
    placement?: string,
    width?: string,
    height?: string,
    dismiss?: boolean,
    label?: string
}

const MismatchEpletDetails = (props: IProps) => {
    let {
        name,
        hasAntibodyReactivity,
        residue,
        foundIn,
        notes
    } = props.eplet;

    let buttonLabel = hasAntibodyReactivity ? 'danger' : 'warning';
    let antiBody = hasAntibodyReactivity ? 'Yes' : 'No';

    let Overlay = (
        <PopoverTemplate dismiss={props.dismiss}>
            <div style={{ width: 350 }}>
                <div style={{ marginBottom: 10, fontSize: 'large', padding: 5 }}>Eplet Details</div>
                <EpletDetailsTableWrapper condensed striped>
                    <tbody>
                        <tr>
                            <td style={{ width: '25%' }}><strong>Residue:</strong></td>
                            <td style={{ width: '75%' }}>{residue}</td>
                        </tr>
                        <tr>
                            <td><strong>Antibody:</strong></td>
                            <td>{antiBody}</td>
                        </tr>
                        <tr>
                            <td><strong>Found In</strong>:</td>
                            <td>{foundIn}</td>
                        </tr>
                        {notes && (
                            <tr>
                                <td colSpan={2}>
                                    <Row>
                                        <Col xs={12}>
                                            <Col xs={12}><b><Glyphicon glyph='info-sign' /> Notes:</b></Col>
                                            <Col xs={12}>{notes}</Col>
                                        </Col>
                                    </Row>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </EpletDetailsTableWrapper>
            </div>
        </PopoverTemplate>
    );

    return (
        <div>
            <OverlayTrigger trigger='click' placement={props.placement != null ? props.placement : 'right'} rootClose overlay={Overlay}>
                <Button bsStyle={buttonLabel} bsSize='xs' style={{ height: props.height, width: props.width ? props.width : '100%', marginBottom: '4px' }}>
                    {name}{notes && (<span>&nbsp;&nbsp;<span className='glyphicon glyphicon-info-sign'></span></span>)}
                </Button>
            </OverlayTrigger>
        </div>
    );
}

export default MismatchEpletDetails;